import React, { useState } from "react";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { InView } from "react-intersection-observer";
import Box from "react-raster";
import Container from "../Container";
import { Copy } from "../Typography";

const Wrapper = styled.div`
  margin-bottom: 100px;
`;

const ImageWrapper = styled.div`
  position: sticky;
  top: 92px;
  z-index: 1;
`;

const Image = styled(GatsbyImage)`
  height: 500px;

  @media (${({ theme }) => theme.mq.l}) {
    height: auto;
  }
`;

const StickyBox = styled(Box)`
  position: sticky;
  top: calc(15vh + 92px);
  z-index: 1000;
  height: 120vh;
  opacity: ${({ inview }) => (inview === "true" ? 1 : 0)};
  transition: opacity 0.3s;
`;

const Spacer = styled(Box)`
  height: 50vh;
`;

/**
 *
 * FIXME: This is re-rendering A LOT while it's in the viewport. The threshold
 * array is the culprit (see notes below https://www.npmjs.com/package/react-intersection-observer#plain-children).
 * But if we declare it as a constant outside the functional component, the animation no longer
 * works when scrolling up. Investigate.
 *
 */

function OverImage({ image, contentAreas }) {
  const [activeBox, setActiveBox] = useState(null);
  const handleBoxIntersection = (inView, i) => {
    if (inView && activeBox !== i) {
      setActiveBox(i);
    }
  };

  return (
    <Wrapper>
      <ImageWrapper>
        <Image image={getImage(image)} />
      </ImageWrapper>
      <Container
        styles={`
          align-self: flex-start; // allows stickiness
        `}
      >
        {contentAreas.map((contentArea, i) => (
          <InView
            threshold={[0.7, 0]}
            onChange={(inView) => handleBoxIntersection(inView, i)}
            key={contentArea.id}
          >
            {({ ref }) => (
              <StickyBox
                inview={activeBox === i ? "true" : "false"}
                cols={[6, 8, 5]}
                marginRight={[0, 4, 7]}
              >
                <div ref={ref}>
                  <Copy colour="white" medium>
                    {contentArea.description}
                  </Copy>
                </div>
              </StickyBox>
            )}
          </InView>
        ))}
        <Spacer />
      </Container>
    </Wrapper>
  );
}

export default OverImage;
